import React from 'react';
import './Activity.css';

const activities = [
  { id: 1, name: "KAYAKING", img: "/images/kayakinggirls.jpg" },
  { id: 2, name: "BONFIRE WITH FRIENDS", img: "/images/bonfirefamily.jpg" },
  { id: 3, name: "CAMPING IN NATURE", img: "/images/camping1.jpg" },
  { id: 4, name: "PADDLE BOATING", img: "/images/paddlingcouple.jpg" },
  { id: 5, name: "TESTY MEAL", img: "/images/tandoor.jpg" },
  { id: 6, name: "WATER SCOOTER", img: "/images/WaterScooter.jpg" }
];

export default function Activity() {
  return (
    <div className="activity-page-bg py-5">
      <div className="container">
        {/* HEADER SECTION */}
        <div className="text-center text-white mb-5">
          <h1 className="fw-bold display-4 mb-3" style={{ fontFamily: 'serif' }}>Experience Best Of NIVARA </h1>
          <p className="mx-auto lead" style={{ maxWidth: '700px', opacity: '0.8', fontSize: '1rem' }}>
            Enjoy nature, adventure, delicious food, and unforgettable moments with family and friends at Nivara Agro Tourism.
          </p>
        </div>

        {/* GRID SECTION */}
        <div className="row g-4">
          {activities.map((act) => (
            <div className="col-lg-4 col-md-6" key={act.id}>
              <div className="activity-card shadow-sm border-0">
                <div className="activity-img-wrapper">
                  <img src={act.img} alt={act.name} className="img-fluid w-100" />
                  <div className="activity-overlay"></div>
                </div>
                <div className="activity-footer text-center py-3">
                  <h4 className="fw-bold mb-0" style={{ letterSpacing: '1px' }}>{act.name}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          {/* <small className="text-white-50">Images from <a href="#" className="text-white text-decoration-underline">Freepik</a></small> */}
        </div>
      </div>
    </div>
  );
}